import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "qrlink" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "action" }
const _hoisted_14 = { class: "message" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Snackbar = _resolveComponent("Snackbar")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      (_ctx.project.name !== '')
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, [
            _cache[11] || (_cache[11] = _createTextVNode(" プロファイル: ", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.project.name), 1)
          ]))
        : (_openBlock(), _createElementBlock("h1", _hoisted_3, "プロファイル")),
      _createVNode(_component_Snackbar, { option: _ctx.snackbar }, null, 8, ["option"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", null, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _cache[12] || (_cache[12] = _createElementVNode("th", null, "プロファイル名", -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "field",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.project.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.project.name]
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[13] || (_cache[13] = _createElementVNode("th", null, "説明", -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "field",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.project.description) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.project.description]
                ])
              ])
            ]),
            (_ctx.edit && this.qrUri)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                  _cache[14] || (_cache[14] = _createElementVNode("th", null, "QRコード表示用URL", -1)),
                  _createElementVNode("td", _hoisted_6, [
                    _createElementVNode("a", {
                      href: this.qrUri,
                      target: "_blank"
                    }, _toDisplayString(this.qrUri), 9, _hoisted_7),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "copy",
                      onClick: _ctx.copyQrUri
                    }, null, 8, ["onClick"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("tr", null, [
              _cache[16] || (_cache[16] = _createElementVNode("th", null, "アイコン", -1)),
              _createElementVNode("td", null, [
                _createElementVNode("input", {
                  type: "file",
                  hidden: "",
                  accept: "image/aces",
                  ref: "pdfInput",
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleInputChange($event)))
                }, null, 544),
                _createElementVNode("div", {
                  class: "dropzone",
                  onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args))),
                  onDragover: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDragover && _ctx.handleDragover(...args)))
                }, [
                  (!_ctx.project.icon || _ctx.project.icon === '')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _cache[15] || (_cache[15] = [
                        _createElementVNode("span", null, "Drop an image file here!", -1)
                      ])))
                    : (_openBlock(), _createElementBlock("p", _hoisted_9, [
                        _createElementVNode("img", { src: _ctx.iconUrl }, null, 8, _hoisted_10),
                        _createVNode(_component_font_awesome_icon, {
                          icon: "minus-circle",
                          onClick: _ctx.resetIcon
                        }, null, 8, ["onClick"])
                      ]))
                ], 32)
              ])
            ]),
            (_ctx.edit && _ctx.project.created)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                  _cache[17] || (_cache[17] = _createElementVNode("th", null, "作成日時", -1)),
                  _createElementVNode("td", null, _toDisplayString(new Date(_ctx.project.created).toLocaleString()), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.edit && _ctx.project.updated)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                  _cache[18] || (_cache[18] = _createElementVNode("th", null, "更新日時", -1)),
                  _createElementVNode("td", null, _toDisplayString(new Date(_ctx.project.updated).toLocaleString()), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("nav", null, [
          (!_ctx.edit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-secondary",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)))
              }, "追加"))
            : _createCommentVNode("", true),
          (_ctx.edit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-secondary",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args)))
              }, "更新"))
            : _createCommentVNode("", true),
          (_ctx.edit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn btn-danger",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
              }, "削除"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      ref: "remove",
      class: "dialog"
    }, {
      default: _withCtx(() => [
        _cache[19] || (_cache[19] = _createElementVNode("h4", { class: "title" }, "Confirm", -1)),
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "message" }, [
          _createElementVNode("p", { class: "text" }, "Do you really remove this profile?")
        ], -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "btn btn-light",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.removeCancel && _ctx.removeCancel(...args)))
          }, "Cancel"),
          _createElementVNode("button", {
            class: "btn btn-danger",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.removeConfirmed && _ctx.removeConfirmed(...args)))
          }, "削除")
        ])
      ]),
      _: 1,
      __: [19,20]
    }, 512),
    _createVNode(_component_Dialog, {
      ref: "error",
      class: "dialog"
    }, {
      default: _withCtx(() => [
        _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "title" }, "Error", -1)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.error.message), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            class: "btn btn-light",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.errorClose && _ctx.errorClose(...args)))
          }, "Close")
        ])
      ]),
      _: 1,
      __: [21]
    }, 512)
  ], 64))
}